import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";
import { StatusChip } from "@/components/StatusChip";
import { ProgressBar } from "@/components/ProgressBar";
import { Search } from "lucide-react";

export default function NursesPage() {
  const navigate = useNavigate();
  const [nurses, setNurses] = useState(null);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = async () => {
    try {
      const r = await api.get("/admin/nurses", { params: { q, status } });
      setNurses(r.data.nurses);
    } catch (e) { toast.error(apiError(e)); }
  };
  useEffect(() => { load(); }, [status]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [q]);

  return (
    <div className="space-y-6" data-testid="admin-nurses">
      <h1 className="text-[32px] font-bold text-[#1c1b1b]">Nurses</h1>
      <div className="flex gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
          <input data-testid="nurse-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email"
            className="h-11 w-full rounded-lg border border-[#E5E7EB] bg-white pl-10 pr-4 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#003d9b]" />
        </div>
        <select data-testid="nurse-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}
          className="h-11 rounded-lg border border-[#E5E7EB] bg-white px-4 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#003d9b]">
          <option value="">All access</option>
          <option value="none">Not requested</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      {!nurses ? <Loader /> : (
        <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#E5E7EB] bg-[#fcf9f8]">
                {["Name", "Email", "Access", "Account", "Progress"].map((h) => (
                  <th key={h} className="text-left text-[12px] font-bold uppercase tracking-wider text-[#434654] px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {nurses.map((n) => (
                <tr key={n.id} data-testid={`nurse-row-${n.id}`} onClick={() => navigate(`/admin/nurses/${n.id}`)}
                  className="border-b border-[#E5E7EB] last:border-0 hover:bg-[#fcf9f8] cursor-pointer">
                  <td className="px-4 py-3 font-semibold text-[#1c1b1b]">{n.name}</td>
                  <td className="px-4 py-3 text-sm text-[#434654]">{n.email}</td>
                  <td className="px-4 py-3"><StatusChip status={n.access_status} /></td>
                  <td className="px-4 py-3"><StatusChip status={n.account_status} /></td>
                  <td className="px-4 py-3 w-[160px]">
                    <ProgressBar value={n.progress} />
                    <span className="text-xs text-[#434654]">{n.modules_completed}/{n.modules_total}</span>
                  </td>
                </tr>
              ))}
              {nurses.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-8 text-center text-sm text-[#434654]" data-testid="nurses-empty">No nurses found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
